// Seguridad del Ecosistema R₿L — i18n (ES/EN/SK).

const ES = {
  title: "Seguridad del Ecosistema",
  contractsVerified: "Contratos verificados en Basescan",
  lpLocked: "LP bloqueado via PinkLock (12 meses)",
  antiReplay: "Protección anti-replay activa",
  rateLimiting: "Rate limiting en todos los endpoints",
  onchainValidation: "Validación on-chain en cada transacción",
  treasuryProtected: "Treasury wallet protegida server-side",
  inputValidation: "Inputs sanitizados y validados",
  securityLogging: "Logging de eventos de seguridad",
  lastAudit: "Última auditoría",
  viewReport: "Ver informe completo",
  securityReport: "Informe de Seguridad",
  // Página /security-audit
  reportSub: "Todas las medidas activas en el ecosistema $R₿L — verificables de forma independiente",
  sectionMeasures: "Medidas de seguridad implementadas",
  sectionContracts: "Contratos y direcciones verificables",
  sectionStats: "Estadísticas (últimos 30 días)",
  sectionEvents: "Historial de eventos de seguridad (30 días)",
  contractToken: "Contrato $R₿L",
  treasuryWallet: "Treasury wallet (recibe pagos — clave solo server-side)",
  burnAddressLabel: "Dirección de quema",
  totalBurned: "Total quemado",
  lpLockLabel: "LP Lock",
  lpLockValue: "PinkLock · 12 meses",
  verifyPinklock: "Verificar en PinkLock",
  verifyBasescan: "Ver en Basescan",
  treasuryBalance: "Balance treasury",
  statEvents: "Eventos registrados",
  statReplay: "Replays bloqueados",
  statRateLimited: "Rate limits aplicados",
  statTxLogged: "TXs auditadas",
  noEvents: "Sin incidentes registrados en los últimos 30 días",
  eventType: "Tipo",
  eventSeverity: "Severidad",
  eventEndpoint: "Endpoint",
  eventDate: "Fecha",
  network: "Red",
  backToToken: "Volver al token",
  loading: "Cargando informe…",
};

const EN = {
  title: "Ecosystem Security",
  contractsVerified: "Contracts verified on Basescan",
  lpLocked: "LP locked via PinkLock (12 months)",
  antiReplay: "Anti-replay protection active",
  rateLimiting: "Rate limiting on all endpoints",
  onchainValidation: "On-chain validation on every transaction",
  treasuryProtected: "Treasury wallet protected server-side",
  inputValidation: "Inputs sanitized and validated",
  securityLogging: "Security event logging",
  lastAudit: "Last audit",
  viewReport: "View full report",
  securityReport: "Security Report",
  reportSub: "All measures active in the $R₿L ecosystem — independently verifiable",
  sectionMeasures: "Implemented security measures",
  sectionContracts: "Verifiable contracts and addresses",
  sectionStats: "Statistics (last 30 days)",
  sectionEvents: "Security event history (30 days)",
  contractToken: "$R₿L Contract",
  treasuryWallet: "Treasury wallet (receives payments — key server-side only)",
  burnAddressLabel: "Burn address",
  totalBurned: "Total burned",
  lpLockLabel: "LP Lock",
  lpLockValue: "PinkLock · 12 months",
  verifyPinklock: "Verify on PinkLock",
  verifyBasescan: "View on Basescan",
  treasuryBalance: "Treasury balance",
  statEvents: "Events logged",
  statReplay: "Replays blocked",
  statRateLimited: "Rate limits applied",
  statTxLogged: "TXs audited",
  noEvents: "No incidents recorded in the last 30 days",
  eventType: "Type",
  eventSeverity: "Severity",
  eventEndpoint: "Endpoint",
  eventDate: "Date",
  network: "Network",
  backToToken: "Back to token",
  loading: "Loading report…",
};

const SK = {
  title: "Bezpečnosť ekosystému",
  contractsVerified: "Zmluvy overené na Basescan",
  lpLocked: "LP uzamknuté cez PinkLock (12 mesiacov)",
  antiReplay: "Anti-replay ochrana aktívna",
  rateLimiting: "Rate limiting na všetkých endpointoch",
  onchainValidation: "On-chain validácia pri každej transakcii",
  treasuryProtected: "Treasury peňaženka chránená na serveri",
  inputValidation: "Vstupy sanitizované a validované",
  securityLogging: "Logovanie bezpečnostných udalostí",
  lastAudit: "Posledný audit",
  viewReport: "Zobraziť úplnú správu",
  securityReport: "Bezpečnostná správa",
  reportSub: "Všetky opatrenia aktívne v ekosystéme $R₿L — nezávisle overiteľné",
  sectionMeasures: "Implementované bezpečnostné opatrenia",
  sectionContracts: "Overiteľné zmluvy a adresy",
  sectionStats: "Štatistiky (posledných 30 dní)",
  sectionEvents: "História bezpečnostných udalostí (30 dní)",
  contractToken: "Zmluva $R₿L",
  treasuryWallet: "Treasury peňaženka (prijíma platby — kľúč len na serveri)",
  burnAddressLabel: "Adresa spaľovania",
  totalBurned: "Celkovo spálené",
  lpLockLabel: "LP Lock",
  lpLockValue: "PinkLock · 12 mesiacov",
  verifyPinklock: "Overiť na PinkLock",
  verifyBasescan: "Zobraziť na Basescan",
  treasuryBalance: "Zostatok treasury",
  statEvents: "Zaznamenané udalosti",
  statReplay: "Zablokované replaye",
  statRateLimited: "Aplikované rate limity",
  statTxLogged: "Auditované TX",
  noEvents: "Žiadne incidenty za posledných 30 dní",
  eventType: "Typ",
  eventSeverity: "Závažnosť",
  eventEndpoint: "Endpoint",
  eventDate: "Dátum",
  network: "Sieť",
  backToToken: "Späť na token",
  loading: "Načítavam správu…",
};

const DE = {
  title: "Sicherheit des Ökosystems",
  contractsVerified: "Verträge verifiziert auf Basescan",
  lpLocked: "LP gesperrt via PinkLock (12 Monate)",
  antiReplay: "Anti-Replay-Schutz aktiv",
  rateLimiting: "Rate Limiting auf allen Endpoints",
  onchainValidation: "On-Chain-Validierung bei jeder Transaktion",
  treasuryProtected: "Treasury Wallet serverseitig geschützt",
  inputValidation: "Inputs bereinigt und validiert",
  securityLogging: "Logging von Sicherheitsereignissen",
  lastAudit: "Letztes Audit",
  viewReport: "Vollständigen Bericht ansehen",
  securityReport: "Sicherheitsbericht",
  reportSub: "Alle aktiven Maßnahmen im $R₿L-Ökosystem — unabhängig überprüfbar",
  sectionMeasures: "Implementierte Sicherheitsmaßnahmen",
  sectionContracts: "Verifizierbare Verträge und Adressen",
  sectionStats: "Statistiken (letzte 30 Tage)",
  sectionEvents: "Verlauf der Sicherheitsereignisse (30 Tage)",
  contractToken: "$R₿L-Vertrag",
  treasuryWallet: "Treasury Wallet (empfängt Zahlungen — Schlüssel nur serverseitig)",
  burnAddressLabel: "Burn-Adresse",
  totalBurned: "Insgesamt geburnt",
  lpLockLabel: "LP Lock",
  lpLockValue: "PinkLock · 12 Monate",
  verifyPinklock: "Auf PinkLock verifizieren",
  verifyBasescan: "Auf Basescan ansehen",
  treasuryBalance: "Treasury-Saldo",
  statEvents: "Registrierte Ereignisse",
  statReplay: "Blockierte Replays",
  statRateLimited: "Angewandte Rate Limits",
  statTxLogged: "Auditierte TXs",
  noEvents: "Keine registrierten Vorfälle in den letzten 30 Tagen",
  eventType: "Typ",
  eventSeverity: "Schweregrad",
  eventEndpoint: "Endpoint",
  eventDate: "Datum",
  network: "Netzwerk",
  backToToken: "Zurück zum Token",
  loading: "Bericht wird geladen…",
};

const ZH_CN = {
  title: "生态系统安全",
  contractsVerified: "已在 Basescan 验证的合约",
  lpLocked: "LP 已通过 PinkLock 锁定（12 个月）",
  antiReplay: "反重放攻击保护已启用",
  rateLimiting: "所有端点均已实施速率限制",
  onchainValidation: "每笔交易均经链上验证",
  treasuryProtected: "国库钱包受服务端保护",
  inputValidation: "输入已清理并验证",
  securityLogging: "安全事件日志记录",
  lastAudit: "最近审计",
  viewReport: "查看完整报告",
  securityReport: "安全报告",
  reportSub: "$R₿L 生态系统中所有已启用措施——可独立验证",
  sectionMeasures: "已实施的安全措施",
  sectionContracts: "可验证的合约和地址",
  sectionStats: "统计数据（最近 30 天）",
  sectionEvents: "安全事件历史（30 天）",
  contractToken: "$R₿L 合约",
  treasuryWallet: "国库钱包（接收付款——密钥仅存于服务端）",
  burnAddressLabel: "销毁地址",
  totalBurned: "总销毁量",
  lpLockLabel: "LP 锁定",
  lpLockValue: "PinkLock · 12 个月",
  verifyPinklock: "在 PinkLock 上验证",
  verifyBasescan: "在 Basescan 上查看",
  treasuryBalance: "国库余额",
  statEvents: "已记录事件",
  statReplay: "已拦截重放攻击",
  statRateLimited: "已应用速率限制",
  statTxLogged: "已审计交易",
  noEvents: "最近 30 天无安全事件记录",
  eventType: "类型",
  eventSeverity: "严重程度",
  eventEndpoint: "端点",
  eventDate: "日期",
  network: "网络",
  backToToken: "返回代币",
  loading: "正在加载报告…",
};

const ALL = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const useSecurityI18n = (lang) => ALL[lang] || ES;

// Orden de checks del badge ↔ claves del backend (measures[].key)
export const MEASURE_KEYS = [
  "contractsVerified",
  "lpLocked",
  "antiReplay",
  "rateLimiting",
  "onchainValidation",
  "treasuryProtected",
  "inputValidation",
  "securityLogging",
];
